import React, { useMemo } from "react";

import { useTypedSelector } from "../../../store/models/root.interface";
import Loader from "../../../common/components/Loader";
import StatisticBox, { StatisticsBoxProps } from "../../../common/components/StatisticBox";
import ErrorBoundary from "../../../common/helpers/ErrorBoundary";

const EventsListSidebar = () => {

  const period = useTypedSelector(state => state.event.period);
  const isFiltered = useTypedSelector(state => !!state.event.filteredEventUids);
  const statisticsByPeriod = useTypedSelector(state => state.event.statisticsByPeriod);
  const filteredStatistics = useTypedSelector(state => state.event.filteredStatistics);

  const isLoading = useMemo(() => {
    return (
      (isFiltered ? filteredStatistics : statisticsByPeriod[period]) ===
      "loading"
    );
  }, [period, isFiltered, filteredStatistics, statisticsByPeriod]);

  const stats = useMemo(() => {
    const source = isFiltered ? filteredStatistics : statisticsByPeriod[period];
    const isLoading = source === "loading";
    const isError = source === "error";
    const state = typeof source !== "string" ? source : void 0;
    const arr: StatisticsBoxProps[] = [
      {
        title: "Total Events",
        value: state?.events?.total,
        results: [
          {
            title: "Previous",
            value: state?.events?.previous,
          },
          {
            title: "Upcoming",
            value: state?.events?.upcoming,
          },
        ],
      },
      {
        title: "Satisfaction Score",
        value: state ? state.scores?.overall ?? "-" : void 0,
        description: state?.scores ? "average" : "None available",
        isPercent: !!state?.scores,
        results: [
          {
            title: "Avg. Content",
            value: state ? state.scores?.content ?? "-" : void 0,
            isPercent: !!state?.scores,
          },
          {
            title: "Avg. Presenter",
            value: state ? state.scores?.presenter ?? "-" : void 0,
            isPercent: !!state?.scores,
          },
        ],
      },
    ];
    return arr;
  }, [period, isFiltered, filteredStatistics, statisticsByPeriod]);

  return (
    <div className="sidebarWrapper">
      {stats.map((x, i) => (
        <div key={i} className="position-relative m-3">
          <ErrorBoundary>
            <StatisticBox {...x} />
            <Loader show={isLoading} />
          </ErrorBoundary>
        </div>
      ))}
    </div>
  );
};

export default EventsListSidebar;
